// Admin Routing

import AdminProductsPage from "components/pages/admin/AdminProductsPage";
import AdminCategoriesPage from "components/pages/admin/AdminCategoriesPage";

const ADMIN_ROUTES = {
	path: "admin",
	children: [
		{ path: "products", element: <AdminProductsPage /> },
		{ path: "categories", element: <AdminCategoriesPage /> },
	],
};

export default ADMIN_ROUTES;
